import * as React from "react";
import BasicCard from "./BasicCard";
import Filter from "../components/Filter";
import DataTable from "../components/DataTable";
import MainLayout from "./MainLayout";
import Dummylayout from "./Dummylayout";

let role = localStorage.getItem("userrole");
// let role = "ROLE_HR";

let searchString = "ROLE_";
let rolename = "";

if (role) {
  rolename = role.substring(role.indexOf(searchString) + searchString.length);
} else {
  rolename = "guest";
}

function GoalsTable() {
  if (
    role === "ROLE_HR" ||
    role === "ROLE_SENIOR HR MANAGER" ||
    role === "ROLE_MANAGER"
  )
    return (
      <>
        <div>
          {" "}
          <Dummylayout />
        </div>
        <div className="">
          {" "}
          <BasicCard>
            <div className="row border-1">
              <div className="col-lg-6">
                <h4 className="text-start pb-3">KPI</h4>
              </div>
              <div className="col-lg-6 text-end bg-white ">
                <a href="GoalsForm" className="text-decoration-none text-white">
                  <button type="button" class="btn btn-danger rounded-pill">
                    Add KPI
                  </button>
                </a>
              </div>
            </div>

            <DataTable />
          </BasicCard>
        </div>
      </>
    );
  if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR")
    return (
      <>
        <div>
          {" "}
          <Dummylayout />
        </div>
        <div className="">
          {" "}
          <BasicCard>
            <div className="row border-1">
              <div className="col-lg-6">
                <h4 className="text-start pb-3">KPI</h4>
              </div>
              <div className="col-lg-6 text-end bg-white "></div>
            </div>

            <DataTable />
          </BasicCard>
        </div>
      </>
    );
  if (role === "ROLE_USER")
    return (
      <>
        <div>
          {" "}
          <Dummylayout />
        </div>
        <div className="">
          {" "}
          <BasicCard>
            <div className="row border-1">
              <div className="col-lg-6">
                <h4 className="text-start pb-3">KPI</h4>
              </div>
              <div className="col-lg-6 text-end bg-white"></div>
            </div>

            <DataTable />
          </BasicCard>
        </div>
      </>
    );
}
export default GoalsTable;
